import React from "react";
import { TextField as MuiTextField, TextFieldProps, InputAdornment } from "@mui/material";
import textFieldStyles from "./form-control-styles";

interface CustomTextFieldProps extends Omit<TextFieldProps, "variant"> {
  startIcon?: React.ReactNode;
  endIcon?: React.ReactNode;
  customStyles?: React.CSSProperties;
}

const TextField: React.FC<CustomTextFieldProps> = ({
  startIcon,
  endIcon,
  customStyles,
  value,
  ...props
}) => (
  <MuiTextField
    fullWidth
    value={value}
    variant="outlined"
    {...props}
    slotProps={{
      input: {
        ...props.slotProps?.input,
        sx: {
          ...textFieldStyles.input,
          ...customStyles
        },
        startAdornment: startIcon && (
          <InputAdornment position="start" sx={textFieldStyles.icon}>
            {startIcon}
          </InputAdornment>
        ),
        endAdornment:
          endIcon && Boolean(value) ? (
            <InputAdornment sx={textFieldStyles.visibilityBtn} position="end">
              {endIcon}
            </InputAdornment>
          ) : (
            <span style={textFieldStyles.visibilityContainer} />
          )
      }
    }}
  />
);

export default TextField;
